/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useFormik } from "formik";
import clsx from "clsx";
import {
  ChefRegister,
  initialValuesChefRegister as initialValues,
} from "../core/_models";
import { useState } from "react";
import {
  chefRegisteration,
  checkDuplicateEmail,
  sendOtpData,
} from "../core/_requests";
import { useNavigate } from "react-router-dom";
import { SocialSignup } from "../socialsignup/SocialSignup";
import { toast } from "react-toastify";
import { signupSchema } from "../core/Schema"; 
import { saveFcmTokenToServer } from "../firebase/NotificationService";

interface LatLng {
  lat: number;
  lng: number;
}

const Signup = (libraries: any) => {
  const navigate = useNavigate();
  const [data, setData] = useState<ChefRegister>(initialValues);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isDuplicateEmail, setDuplicateEmail] = useState("");

  const handleClose = () => {
    setShowAlert(false);
  };

  

  const formik = useFormik<ChefRegister>({
    initialValues,
    validationSchema: signupSchema,
    onSubmit: async (values) => {
     values.signupType = 1;//1-normal signup
      const updatedData = { ...data, ...values }; // ✅ Create a new object instead of modifying `data`
      
      setLoading(true);

      try {
        const res: any = await chefRegisteration(updatedData);

        if (res?.status === true) {
          
          otpSendEmailAfterSignup(res.data.uuid);
          localStorage.setItem("chefemail", res.data?.email);
          localStorage.setItem("chefuuid", res.data.uuid);
           localStorage.setItem("signupType", "normal");
          localStorage.setItem("chefdata", JSON.stringify(res.data)); // ✅ Ensure data is stored correctly
        await saveFcmTokenToServer({
            userId: res.data.uuid,
            userType: "chef",
            appVersion: "1.0.0",
          });
        
        } else {
          setErrorMessage(res?.message);
          setShowAlert(true);
        }
      } catch (error) {
        console.error("Signup error:", error);
        setErrorMessage("Something went wrong. Please try again.");
        setShowAlert(true);
      } finally {
        setLoading(false); // ✅ Always stop loading after the request
      }
    },
  });
 
  const otpSendEmailAfterSignup = (chefId: any) => {
    const data = {
      type: 1,
      email: formik.values.email,
      chefId
    };
    

    sendOtpData(data).then((res) => {
      if (res?.status === true) {
        navigate("/otp-verification");
        toast.success(res?.message, { autoClose: 5000 });
      } else {
        toast.error(res?.message);
        setErrorMessage(res?.message);
      }
    });
  };

  const handleLogin = () => {
    localStorage.clear();
    navigate("/login");
  };
  const onClickCancel = () => {
    navigate("/");
  };

  
  return (
    <div className="container-fluid signup-sec py-3">
      <div className="row">
        <div className="col-xl-5 col-md-5 d-none d-lg-block ">
          <div className="signup-img">
            <img
              src="/assets/images/signup-grid.png"
              className="img-fluid"
              alt="img-grid"
            />
          </div>
        </div>
        <div className="col-xl-7 col-lg-7">
          <div className="right-form px-3 mt-md-1 mt-3 d-flex justify-content-between flex-column">
            <div className="col-12 col-lg-12 d-flex align-item-center">
              <div className="col-lg-4"></div>
              <div className="col-lg-2 mx-5">
                <div className="logo-wrap">
                  <img
                    src="/assets/images/logo.svg"
                    className="img-fluid w-100"
                    alt="logo"
                  />
                </div>
              </div>
              <div className="col-lg-4"></div>
            </div>
            <h1 className="mb-md-3 mb-2 fs-5 text-center">
              Elevate Your <span>Culinary Journey</span>
              <span>Sign Up Now!</span>
            </h1>
            {showAlert ? (
              // <div className="mb-lg-15 alert alert-danger">
              <div
                className={`mb-lg-10 alert ${showAlert ? "alert-danger" : "alert-success"
                  }`}
              >
                <div className="alert-text font-weight-bold">
                  {errorMessage}
                  <button
                    className="btn p-0 close d-inline-end"
                    onClick={handleClose}
                  >
                    <i className="material-symbols-outlined fs-18  px-10">
                      close
                    </i>
                  </button>
                </div>
              </div>
            ) : null}
            <form
              onSubmit={formik.handleSubmit}
              noValidate
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent form submission on Enter key
                }
              }}
              className="custom-form"
            >
              <div className="content-sec mx-4">
                <div className="row text-center align-item-center">
                  <div className="col-md-12 px-2">
                    <div className="col-md-12 text-start">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="small-font mb-2 me-1"
                      >
                        Your Name
                      </label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className={clsx(
                          "form-control",
                          {
                            "is-invalid":
                              formik.touched.name && formik.errors.name,
                          },
                          {
                            "is-valid":
                              formik.touched.name && !formik.errors.name,
                          }
                        )}
                        id="exampleFormControlInput1"
                        placeholder="Ex: Emma Johnson "
                        {...formik.getFieldProps("name")}
                      />

                      {formik.touched.name && formik.errors.name && (
                        <div className="fv-plugins-message-container">
                          <span role="alert">{formik.errors.name}</span>
                        </div>
                      )}
                    </div>
                    <div className="col-md-12 text-start mt-3 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="small-font  mb-2 me-1"
                      >
                        Email Address
                      </label>
                      <span className="text-danger">*</span>
                      <input
                        type="Enter Your Email Address"
                        className={clsx(
                          "form-control",
                          {
                            "is-invalid":
                              formik.touched.email && formik.errors.email,
                          },
                          {
                            "is-valid":
                              formik.touched.email && !formik.errors.email,
                          }
                        )}
                        placeholder="Your mail address"
                        {...formik.getFieldProps("email")}
                        onChange={(e) => {
                          formik.handleChange(e);
                          // Perform duplicate check here
                          checkDuplicateEmail(e.target.value).then((response) => {
                            if (response?.status === true) {
                              setDuplicateEmail(response?.message);
                            } else {
                              setDuplicateEmail("");
                            }
                          });
                        }}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="fv-plugins-message-container">
                          <span role="alert">{formik.errors.email}</span>
                        </div>
                      )}
                      <span style={{ color: "red" }}>
                        {isDuplicateEmail ? isDuplicateEmail : ""}
                      </span>
                    </div>
                    <div className="col-md-12 text-start mt-3 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="small-font  mb-2 me-1"
                      >
                        Password
                      </label>
                      <span className="text-danger">*</span>
                      <input
                        type="Enter Your Password"
                        className={clsx(
                          "form-control",
                          {
                            "is-invalid":
                              formik.touched.password && formik.errors.password,
                          },
                          {
                            "is-valid":
                              formik.touched.password && !formik.errors.password,
                          }
                        )}
                        placeholder="Your password"
                        {...formik.getFieldProps("password")}
                      />
                      {formik.touched.password && formik.errors.password && (
                        <div className="fv-plugins-message-container">
                          <span role="alert">{formik.errors.password}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="signup-action mt-3 d-flex gap-3 justify-content-md-between flex-xl-row justify-content-sm-start flex-sm-column form-check form-check-inline">
                    <span className="tiny-font opacity-80  align-self-xl-center align-self-sm-start">
                      <input
                        className="form-check-input me-3"
                        type="checkbox"
                        id="addonCheck"
                        value="option1"
                        onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
                      />{" "}
                      “Sign Up” to continue you are accepting our {""}
                      <a
                        href="https://frayo.net/terms-and-condition"
                        className="opacity-80"
                        target="_blank"
                      >
                        Terms & Conditions
                      </a>
                    </span>
                    {!isCheckboxChecked && (
                      <>
                        {/* Show only on small devices (sm and below) */}
                        <span className="text-danger d-md-none">
                          Please check the confirmation button*
                        </span>
                      </>
                    )}

                    <div className="d-flex gap-3 justify-content-sm-center">
                      <button type="button"
                        className="btn outline-btn px-4"
                        onClick={onClickCancel}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={
                          !isCheckboxChecked ||
                          formik.isSubmitting ||
                          !formik.isValid ||
                          (formik.touched && !formik.errors)
                        }
                        className="btn primary-btn px-4 cursorPointer"
                      >
                        {!loading && (
                          <span className="indicator-label">Signup</span>
                        )}
                        {loading && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                  {!isCheckboxChecked && (
                    <>
                      {/* Show only on large devices (md and up) */}
                      <span className="text-danger text-start d-none d-md-block">
                        Please check the confirmation button*
                      </span>
                    </>
                  )}
                </div>
              </div>
              <div className="mt-2">
                <SocialSignup />
              </div>
            </form>
            <div className=" mt-3 pt-4 px-3 footer-login">
              <p className="text-center small-font">
                If you have an account.{" "}
                <a onClick={handleLogin} className="link cursorPointer">
                  Login
                </a>{" "}
                here
              </p>
              
              {/* Chef App Download Links */}
              <div className="text-center">
                <p className="small-font mb-3">Download the Chef App</p>
                <div className="d-flex justify-content-center gap-3">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.frayo.business" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="app-download-link"
                  >
                    <img 
                      src="/assets/images/play-store-ico.png.jpg" 
                      alt="Download on Google Play" 
                      className="app-store-badge"
                      style={{ height: '40px', width: 'auto' }}
                    />
                  </a>
                  <a 
                    href="https://apps.apple.com/us/app/frayo-business/id6747029453" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="app-download-link"
                  >
                    <img 
                      src="/assets/images/app-store-ico.png.jpg" 
                      alt="Download on App Store" 
                      className="app-store-badge"
                      style={{ height: '40px', width: 'auto' }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};
export { Signup };